import React from 'react';
import { Container } from '@hpi-sox/hpstellar-core';

import ContentCarousel from '../../../blog/components-v2/content-carousel/content-carousel-visid';

import './related-articles.less';

export default props => {
    return (
        <Container className="clp-related-articles">
            <ContentCarousel {...props} />
        </Container>
    );
};
